const LogLevel = {
    Debug: 0,
    Info: 1,
    Warn: 2,
    Error: 4,
    Fatal: 8
}

class Logger {

    constructor(name, threshholdLevel) {
        this.name = name;
        this.threshholdLevel = threshholdLevel;
    }

    log(level, ...params) {
        if (level >= this.threshholdLevel) {
            switch (level) {
                case LogLevel.Debug, LogLevel.Info:
                    console.log(this.name + ":", ...params);
                    break;
                case LogLevel.Warn:
                    console.warn(this.name + ":", ...params);
                    break;
                case LogLevel.Error, LogLevel.Fatal:
                    console.error(this.name + ":", ...params);
                    break;
            }
        }
    }
}

class LogManagerClass {
    _loggers = [];
    getLogger(name) {
        return this._loggers[name] || (this._loggers[name] = new Logger(name, this.threshholdLevel));
    }

    constructor(threshholdLevel) {
        this.threshholdLevel = threshholdLevel;
    }

}

const LogManager = {
    LogManager: new LogManagerClass(LogLevel.Debug)
};